import type { CategoryScore } from "../types";
import { getScoreFillClass } from "../utils/score";
import { TrendText } from "./common/TrendText";

interface Props {
  scores: CategoryScore[];
}

export default function ScoreBar({ scores }: Props) {
  return (
    <>
      {scores.map((s) => {
        const score = s.score != null ? Math.round(s.score) : 0;
        const cls = getScoreFillClass(score);
        const scoreText = s.score != null ? `${score}점` : "N/A";

        return (
          <div key={s.key}>
            <div className="flex items-center gap-3.5 mb-2.5">
              <span className="w-20 text-sm font-semibold text-zinc-950 dark:text-zinc-100 shrink-0">{s.label}</span>
              <div className="flex-1 h-7 bg-zinc-100 dark:bg-zinc-800 rounded-lg overflow-hidden">
                <div
                  className={`h-full rounded-lg score-fill-transition ${cls}`}
                  style={{ width: `${s.score != null ? score : 0}%` }}
                />
              </div>
              <span className="w-14 text-right text-[15px] font-bold shrink-0 text-zinc-950 dark:text-zinc-100">{scoreText}</span>
            </div>
            <div className="text-xs text-zinc-500 dark:text-zinc-400 -mt-1 mb-3.5 pl-[94px] max-md:pl-0">
              <TrendText text={s.detail} size={13} />
            </div>
          </div>
        );
      })}
    </>
  );
}
